import { useEffect } from 'react'
import { useSettingsState } from '~/atoms/SettingsState'
import { useUserState } from '~/atoms/UserState'
import Logger from '~/services/Logger'

const logger = new Logger('useAgentModeSync')

/**
 * Hook that automatically disables Agent Mode when switching to a PBX that doesn't support agent statuses
 */
export const useAgentModeSync = () => {
  const { agentStatusesEnabled, pbxId } = useUserState()
  const {
    settings: { callCenter },
    setCallCenterAgentEnabled,
  } = useSettingsState(pbxId)

  const isAgentModeEnabled = callCenter?.isEnabled ?? false

  useEffect(() => {
    if (isAgentModeEnabled && !agentStatusesEnabled) {
      logger.info(
        `Disabling Agent Mode because PBX ${pbxId} doesn't support agent statuses`,
      )
      setCallCenterAgentEnabled(false)
    }
  }, [
    agentStatusesEnabled,
    isAgentModeEnabled,
    setCallCenterAgentEnabled,
    pbxId,
  ])
}
